
import React from "react";
import ReactDOM from "react-dom";
import StoreManager from './appdata';
import FaceEnrollScreen from "./screens/FaceEnrollScreen";


import { getAccessToken} from './api';

export default class FaceEnrollApp extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      height: '100vh',// window.innerHeight, // Khởi tạo width ban đầu
      productionKey: false,
      indexStep:0
    }
    this.hasMounted = false; // Thêm cờ ở đây

  }
  async componentDidMount(){
    if (this.hasMounted) return; // Nếu đã chạy thì return

    this.hasMounted = true; // Đặt cờ thành true sau khi chạy lần đầu
    
   await StoreManager.loadDataFromLocal()
    window.addEventListener('resize', this.updateDimensions);
    getAccessToken("face_enroll")

    StoreManager.appdata.thisApp = this
 
    
  }
  componentWillUnmount() {
      // Dọn dẹp event listener khi component bị unmount
      window.removeEventListener('resize', this.updateDimensions);
    
  }
  updateDimensions = () => {
      // this.setState({ height: window.innerHeight + 200 });
  }




  render(){
    const {height} = this.state
    var content =  <FaceEnrollScreen/>

    return  <div id="trueid" style={{backgroundColor: StoreManager.appdata.configEkyc.backgroundColor, flex: 1, height: height}}>
    {
      content
    }
    <p hidden id="status">Initializing...</p>
</div>
  }

}

